import {Yii} from "libraries/interfaces/Yii";

export const WORDING: {[key:string]:string} ={
    beginDate: Yii.t('wui-shared-js', 'Date Aller'),
    endDate: Yii.t('wui-shared-js', 'Date Retour'),
    date: Yii.t('wui-shared-js', 'Date'),
    nights: Yii.t('wui-shared-js','Nuits')
};
